import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import Notification from "../../shared/components/Notification";
import { notifications } from "../actions";
import { notificationsSelectors } from "../selectors";

class Notifications extends React.Component {
  clear = id => {
    const { remove } = this.props;
    remove(id);
  };

  render() {
    const { notifications } = this.props;
    if (notifications.length > 0) {
      const notificationList = notifications.map(notification => (
        <Notification
          key={notification.id}
          id={notification.id}
          type={notification.type}
          status={notification.description}
          message={notification.message}
          action={notification.action}
          timer={notification.timer}
          dismissable
          onDismiss={this.clear}
        />
      ));
      return (
        <div className="p-notifications-container">{notificationList}</div>
      );
    }
    return null;
  }
}

Notifications.propTypes = {
  notifications: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      message: PropTypes.string.isRequired
    })
  ).isRequired,
  remove: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  notifications: notificationsSelectors.getAll(state)
});

const mapDispatchToProps = {
  remove: notifications.remove
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Notifications);
